import { render, staticRenderFns } from "./metertab.vue.html?vue&type=template&id=28ddd092"
import script from "./metertab.controller.ts?vue&type=script&lang=js&external"
export * from "./metertab.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports